<template>
  <div class="wrapper">
    <div id="main-reports" class="container-fluid reports-body">
      <div class="col" style="padding: 0;">
        <div class="row no-gutters">
          <div class="col-12">
            <dashboard-bar refreshButton>
              <div slot="menu-reports" style="display: flex;">
                <span style="margin-top: 7px; margin-right: 10px;">
                  <b>{{ this.$t('reports.subTitle') }}:</b>
                </span>
                <b-form-select
                  v-model="selected"
                  :options="options"
                ></b-form-select>
              </div>
            </dashboard-bar>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-12">
            <reports-emotion-cards />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import dashboardBar from '@/components/molecules/dashboard-bar';
import ReportsEmotionCards from '@/components/molecules/reports-emotion-cards';
import api from '@/services/api';
import EventBus from '../../../eventBus';

export default {
  name: 'Reports',
  components: {
    dashboardBar,
    ReportsEmotionCards,
  },
  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapFields('settings', ['country']),
    ...mapState('companies', ['myMetric']),
  },
  watch: {
    selected: async function watchSelected(value) {
      EventBus.$emit('report', value);
      EventBus.$emit('sendSelection', value);
    },

    country: async function watchCountry() {
      await this.getReportsMenu();
    },

    myMetric: async function watchMyMetric() {
      await this.getReportsMenu();
      this.getReportOptionName();
    },

    $i18n: function watchLanguage() {
      this.getReportOptionName();
    },
  },
  data: () => ({
    selected: null,
    userAuth: null,
    options: [],
  }),

  methods: {
    async getReportsMenu() {
      let { data } = await api.get(`/report-companies`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          companyId: this.userAuth.companyId,
        },
      });
      const reportCompany = data;
      data = await api.get(`/reports`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      const reportProfileData = await api.get('/get-profile-report', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      const reportProfile = reportProfileData.data.reportsProfile;

      const reports = data.data.filter((item) => item.reportType !== 'powerbi');

      this.options = [{ value: null, text: this.$t('reports.selectReport') }];
      for (let i = 0; i < reports.length; i += 1) {
        const reportName = this.getReportOptionName(reports[i].reportName);

        if (reports[i].reportType === 'geral') {
          this.options.push({
            value: reports[i].reportName,
            text: reportName ? reportName : reports[i].reportName,
          });
        } else if (
          this.userProfile.type === 'admin' ||
          this.userProfile.type === 'master'
        ) {
          for (let j = 0; j < reportCompany.length; j += 1) {
            if (reportCompany[j].reportId === reports[i]._id) {
              this.options.push({
                value: reports[i].reportName,
                text: reportName ? reportName : reports[i].reportName,
              });
              break;
            }
          }
        } else if (reports[i].reportType === 'especifico') {
          // This code have to be fixed after creating profileList in user collection
          if (
            (reports[i]._id === '60ec3097967a322d04cbb26a' ||
              reports[i]._id === '6026a468451b7049873a0300' ||
              reports[i]._id === '5fdd0ee38c14825c903c59bb') &&
            this.userAuth.companyId === '61965aa04be7ea63c8f83435'
          ) {
            this.options.push({
              value: reports[i].reportName,
              text: reportName ? reportName : reports[i].reportName,
            });
          } else {
            for (let j = 0; j < reportProfile.length; j += 1) {
              if (
                reports[i]._id === reportProfile[j].reportId &&
                this.userAuth.profileId === reportProfile[j].profileId
              ) {
                this.options.push({
                  value: reports[i].reportName,
                  text: reportName ? reportName : reports[i].reportName,
                });
                break;
              }
            }
          }
          if(reports[i].reportName === 'Monitoramento de Tratativa'){
            const reportEspecifico = reportCompany.find(item => item.reportId === reports[i]._id);
            if(reportEspecifico){
              this.options.push({
                value: reports[i].reportName,
                text: reportName ? reportName : reports[i].reportName,
              });
            }
          }
        }
      }
    },

    getReportOptionName(reportKey) {
      const reportNames = this.$i18n.messages[this.$i18n.locale].reports
        .reportTitles;

      for (let i = 0; i < reportNames.length; i += 1) {
        if (reportNames[i].key === reportKey) {
          if (this.myMetric.indexOf('nps') !== -1) {
            return reportNames[i].value;
          } else if (this.myMetric.indexOf('ces') !== -1) {
            return reportNames[i].cesValue;
          } else if (this.myMetric === 'csat-1-5') {
            return reportNames[i].csatValue;
          } else if (this.myMetric === 'csat-1-5(media)' || this.myMetric === 'csat-0-10(media)') {
            return reportNames[i].csatValueAverage;
          } else if (this.myMetric === '5-stars') {
            return reportNames[i].fiveStarsValue;
          } else if (this.myMetric === 'like-dislike') {
            return reportNames[i].likeDislikeValue;
          }
        }
      }

      return null;
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (!this.userProfile.permissions.reports.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
  },

  async mounted() {
    await this.getReportsMenu();
    // this.selected = 'Evolução de NPS';
    this.selected = null;

    await this.getReportOptionName();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.wrapper {
  width: 100%;
  .reports-body {
    // @include bg-color($white);
    @each $i in $directions {
      @extend %half-padding-#{$i};
    }
    .report {
      background-color: $white;
      padding: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/reports/index.vue